import React from 'react'
import styles from './MicrositeConversionRate.module.css'

/**
 * MicrositeConversionRate
 * Shows impressions, conversions, and the derived rate % — used on
 * the Popups list to show how each popup is performing.
 *
 * Usage:
 *   <MicrositeConversionRate impressions={row.impressionCount} conversions={row.conversionCount} />
 */
const MicrositeConversionRate = ({ impressions = 0, conversions = 0 }) => {
    const rate = impressions > 0 ? ((conversions / impressions) * 100).toFixed(1) : '0.0'

    return (
        <div className={styles.wrap}>
            <span className={styles.figures}>
                {conversions} / {impressions}
            </span>
            <span className={`${styles.rate} ${rate >= 5 ? styles.rateGood : styles.rateLow}`}>
                {rate}%
            </span>
        </div>
    )
}

export default MicrositeConversionRate